var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4A4A4A;stroke:#4A4A4A;stroke-width:0.5;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.7,8.2c-0.2-0.1-0.4-0.1-0.6,0L23.2,12V9.7c0-1.8-1.4-3.2-3.2-3.2H4.2C2.4,6.6,1,8,1,9.7v12.5 c0,1.8,1.4,3.2,3.2,3.2H20c1.8,0,3.2-1.4,3.2-3.2V20l6.9,3.8c0.2,0.1,0.4,0.1,0.6,0s0.3-0.3,0.3-0.5V8.8C31,8.6,30.9,8.3,30.7,8.2z  M21.9,22.3c0,1.1-0.9,1.9-1.9,1.9H4.2c-1.1,0-1.9-0.9-1.9-1.9V9.7c0-1.1,0.9-1.9,1.9-1.9H20c1.1,0,1.9,0.9,1.9,1.9V22.3z  M29.7,22.2l-6.6-3.6v-5.2l6.6-3.6V22.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetVideo);
export default __webpack_public_path__ + "static/media/met-video.9dc77436f5d397b415862a51dfc73e3c.svg";
export { ForwardRef as ReactComponent };